<template>
  <main class="main cart-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="desc empty-desc" v-if="!$parent.cartContents.length">
            Cart is empty!
          </div>
          <div class="right" v-if="$parent.cartContents.length">
            <div class="title regular">Cart</div>
            <div class="row">
              <div class="desc big">Total:</div>
              <div class="title">
                {{ $parent.totalSum }}
                <span class="currency">{{ $parent.currency }}</span>
              </div>
            </div>
            <button @click="toOrder" class="button red">
              <span>PROCEED TO CHECKOUT</span>
            </button>
          </div>
          <div class="left" v-if="$parent.cartContents.length">
            <div class="product-list">
              <!-- Pack items -->
              <div
                v-for="(item, index) in $parent.cartContents"
                :key="`item-${index}`"
                class="cart-item-container"
                :class="{ 'pack-container': item.type === 'pack' }"
              >
                <PackCartItem
                  v-if="item.type === 'pack'"
                  :cartItem="item"
                  @increment="incrementItem"
                  @decrement="decrementItem"
                  @remove="removeItem"
                  class="pack-item"
                />

                <!-- Regular product items -->
                <template v-else>
                  <div class="item">
                    <div class="item-left">
                      <div
                        class="delete"
                        @click="$parent.removeFromCart(item.item, item.item_id)"
                      >
                        <img src="./../img/bin.svg" class="img" />
                      </div>
                      <div class="preview">
                        <img :src="imgDomain + item.item.img_url" class="img" />
                      </div>
                      <div class="title name">{{ item.item.title }}</div>
                    </div>
                    <div class="item-right">
                      <div class="count">
                        <div
                          class="count__item minus"
                          @click="$parent.removeOneFromCart(item, item.item_id)"
                        ></div>
                        <input
                          type="number"
                          value="1"
                          v-model="item.count"
                          step="1"
                        />
                        <div
                          class="count__item plus"
                          @click="$parent.addToCart(item.item, item.item_id)"
                        ></div>
                      </div>
                      <div class="price">
                        {{ item.item.price }}
                        <span class="currency">{{ $parent.currency }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import PackCartItem from "../components/pack/PackCartItem.vue";

export default {
  name: "Cart",
  props: ["activeCategory"],
  components: {
    PackCartItem,
  },
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    toOrder() {
      this.$router.push({ path: "/pay" });
    },
    incrementItem(item, id, type) {
      this.$parent.addToCart(item, id, 1, type);
    },
    decrementItem(item, id, type) {
      this.$parent.removeOneFromCart(item, id, type);
    },
    removeItem(item, id, type) {
      this.$parent.removeFromCart(item, id, type);
    },
  },
};
</script>
<style scoped>
.cart-item-container + .cart-item-container,
.pack-item + .item,
.pack-item + .pack-item {
  margin-top: 4px;
}
</style>
